import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'

const UsersProtectedRoutes = () => {

    let isUserLoggedIn = 'loggedIn' && 'user';
    return (
        <>
            {
                isUserLoggedIn ? <Outlet /> : <Navigate to={'/'} />
            }
        </>

    )
}

export default UsersProtectedRoutes 